import { defineComponent } from '@nuxtjs/composition-api';
import JobsInquiryHiringsCountQuery from '@/apollo/queries/Jobs/JobsInquiryHiringsCount.query';

export default defineComponent({
  apollo: {
    hiringCount: {
      query: JobsInquiryHiringsCountQuery,
      error(e): void {
        this.$notice.error(e);
      },
      update(data) {
        return data.currentJobsInquiry?.hiringsForReview?.length;
      },
      skip() {
        return !this.$auth.loggedIn;
      },
    },
  },
  data(): { hiringCount: number | null } {
    return {
      hiringCount: null,
    };
  },
});
